import * as React from "react";
import { renderMarketsColumnsFilter } from "../../../../../helpers";
import { HeadingName } from "../../HeadingName";
export class RenderMarketNames extends React.PureComponent {
    render() {
        let trimmed = this.props.queryParams
            ? renderMarketsColumnsFilter(this.props.marketNames, this.props.queryParams)
            : this.props.marketNames;
        return (React.createElement("div", { className: "rj-ev-list__heading__names-wrapper", "data-uat": "div-ev-list-heading-names-wrapper" }, trimmed.map((namesArray, index) => {
            const classNames = this.props.marketTemplates[index]
                ? `rj-ev-list__heading__names--${this.props.marketTemplates[index]}`
                : "";
            return React.createElement("div", { key: `heading-group-${index}`, className: `rj-ev-list__heading__names ${classNames}`, "data-uat": "div-ev-list-heading-names" }, namesArray.map((name, index) => React.createElement(HeadingName, { key: `heading-name-${index}`, name: name })));
        })));
    }
}
//# sourceMappingURL=RenderMarketNames.js.map